module.exports = __webpack_public_path__ + "static/media/sensor-smoke.355cba53.svg";